import { documentsUrl } from 'common/config/urls';

type GetDocumentGenerationJobsDocumentsUrlParams = {
  companySlug?: string | null;
  firmSlug?: string | null;
  routeCompanySlug?: string | null;
  routeFirmSlug?: string | null;
};

export const getDocumentGenerationJobsDocumentsUrl = ({
  companySlug,
  firmSlug,
  routeCompanySlug,
  routeFirmSlug,
}: GetDocumentGenerationJobsDocumentsUrlParams) => {
  const resolvedFirmSlug = routeFirmSlug || firmSlug;
  const resolvedCompanySlug = routeCompanySlug || companySlug;

  return resolvedFirmSlug && resolvedCompanySlug ? documentsUrl(resolvedFirmSlug, resolvedCompanySlug) : null;
};
